module.exports = __webpack_public_path__ + "static/media/albert.a12bf9db.jpg";